import { CopyIcon } from '@phosphor-icons/react'
import { useTranslation } from 'react-i18next'

import { FieldActions, FieldRow, FieldViewValue } from '@/components/layout/field-row'
import { Button } from '@/components/ui/button'
import { Icon } from '@/components/ui/icon'
import { Typography } from '@/components/ui/typography'
import { toastFactory } from '@/factories'
import { Building } from '@/reducers/types'

interface ParcelPendingUrlViewProps {
  building: Building
}

export const ParcelPendingUrlView = ({ building }: ParcelPendingUrlViewProps) => {
  const { t } = useTranslation(['organisation'])
  const url: string = building.quadientWebhook ?? ''

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(url)
      toastFactory.success(t('organisation:places.building.toasts.callbackUrlCopied'))
    } catch {
      toastFactory.error(t('organisation:places.building.toasts.callbackUrlCopyFailed'))
    }
  }

  return (
    <FieldRow label={t('organisation:places.building.parcelPending.label')}>
      <FieldViewValue>
        <FieldActions>
          <Typography size="text-small" color="black800">
            {url || t('organisation:places.building.parcelPending.noCallbackUrl')}
          </Typography>
          <Button disabled={!url} size="small" use="secondary" onClick={handleCopy}>
            <Icon icon={CopyIcon} />
            {t('organisation:places.building.parcelPending.copyButton')}
          </Button>
        </FieldActions>
      </FieldViewValue>
    </FieldRow>
  )
}
